export interface IFormEquipmentDetails {
  location_info: string;
  location_id: string;
  wo_asset_id?: string;
}

export const EQUIPMENT_DETAILS_FIELDS = {
  LOCATION_INFO: 'location_info',
  LOCATION_ID: 'location_id',
  WO_ASSET_ID: 'wo_asset_id',
};
